import { getUmPolicyLimitsLabel, getUMPolicyStatusLabel } from "../../../lib/labels"
import { getUMReducedAmount } from "../../../lib/misc"
import { liabilityFunctions } from "../../../lib/liability"
import CheckboxCell from "../../common/interactive/CheckboxCell"

export default function UMPart({dataItem, activeCase, classes}) {
    const umReducedAmount = dataItem && dataItem.um_type == 1
        ? getUMReducedAmount(liabilityFunctions.isLiabilityValid(activeCase?.liabilities, 'policy_limit_patient'), dataItem)
        : null

    return <>
        {dataItem && dataItem.has_um ? <>
            <h4 className={classes.flex_betwen}>UM 
                <div className={classes.status}>
                    <CheckboxCell label={'UM'} checked={true} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/>
                    {dataItem.um_type == 1 && <CheckboxCell label={'Reduced'} checked={true} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/>}
                    {dataItem.um_type == 0 && <CheckboxCell label={'Addon'} checked={true} isDisabled={true} direction={'reverse'} setStyle={'box_small'}/>}
                </div>
            </h4>
            <div className={classes.background_container}>
                <div className={classes.row}>Carrier: {dataItem.insurance_carrier?.name}</div>
                {dataItem.claim_number && <div className={classes.row}>Claim #: {dataItem.claim_number}</div>}              
       
                {dataItem.um_policy_limit_patient && <div className={classes.row}>
                    {dataItem.um_policy_limit_patient && <> UM Limit Patient: <b>{getUmPolicyLimitsLabel(dataItem.um_policy_limit_patient)}</b></>}
                </div>}
                {dataItem.um_policy_limit_accident && <div className={classes.row}>
                    {dataItem.um_policy_limit_accident && <> UM Limit Accident: <b>{getUmPolicyLimitsLabel(dataItem.um_policy_limit_accident)}</b></>}
                </div>}
                {dataItem.um_type == 1 && umReducedAmount != null && <div className={classes.row}>
                    Amount Available: <b>${umReducedAmount}</b>
                </div>}
                {dataItem.um_status && <div className={classes.row}>
                    {dataItem.um_status && <>Claim Status: <b>{getUMPolicyStatusLabel(dataItem.um_status)}</b></>}
                </div>}
                {dataItem.mp_verified ? <>
                    <hr />
                    <div>Verified by <b>{dataItem.mp_verified_by}</b> at <b>{dataItem.mp_verified_date}</b></div>
                </> : ''}     
            </div>
        </> : ''}
    </>
}